export default "__VITE_ASSET__d7404bcb__"